import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { ExternalLink } from 'lucide-react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';
import { Loader, Tooltip } from '@getro/rombo';

export const ContactResumeRenderer = ({ data, value }) => {
  const { colors } = useTheme();

  if (data.options.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={120}
        viewBox="0 0 400 120"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="20" y="16" rx="3" ry="3" width="80" height="8" />
      </ContentLoader>
    );
  }

  if (!value?.url) {
    return '';
  }

  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%', justifyContent: 'space-between' }}>
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        View resume
      </Text>

      <Box width="16px" height="16px">
        {value.isLoading && <Loader size="small" />}
        {!value.isLoading && (
          <Tooltip
            position="top-end"
            content={
              <Text fontSize="14px" color="neutral.0">
                View resume. 🔒 This file has been scanned and is safe to open
              </Text>
            }
            placement="top"
            trigger={
              <Box
                as={ExternalLink}
                size="16px"
                sx={{ cursor: 'pointer', color: 'text.main' }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  if (!value.isLoading) {
                    value.getResume();
                  }
                }}
              />
            }
          />
        )}
      </Box>
    </Flex>
  );
};

ContactResumeRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object]),
  data: PropTypes.object,
};

ContactResumeRenderer.defaultProps = {
  value: '',
  data: {},
};
